
import axios from 'axios'

export default {
    getGeneral(){
        return axios.get('/generalclass?is_active=1')
            .then(response => {
                return response.data
            })
    },
    getGeneralDataSource(params){
        return axios.get('/generalclass/datasource', {params})
            .then(response => {
                return response.data
            })
    },
    getGeneralbyID(id){
        return axios.get('/generalclass/' + id)
            .then(response => {
                return response.data
            })
    },    
    createGeneral(formdata){
        return axios.post('/generalclass', formdata)
            .then(response => {
                return response.data
            })
    },
    updateGeneral(id,formdata){
        return axios.put('/generalclass/' + id, formdata)
            .then(response => {
                return response.data
            })
    },
    deactivateGeneral(id){
        return axios.put('/generalclass/' + id + '/deactivate')
            .then(response => {
                return response.data
            })
    },
    reactivateGeneral(id){
        return axios.put('/generalclass/' + id + '/reactivate')
            .then(response => {
                return response.data
            })
    },
}